import { SEARCH_PLACEHOLDER } from 'Core-utils/constants/constants';
import { Table } from '../Table';
import { AUTOMOX_POLICIES_COLUMNS, AutomoxPoliciesColumnsType } from './AutomoxPoliciesColumns';
import { Status } from 'Core-utils/helpers/helpers';
import { SearchBar } from 'Components/molecules';
import { useMemo, useState } from 'react';
import { AUTOMOX_POLICIES_MOCK_DATA } from './AutomoxPoliciesMockData';

export interface AutomoxPoliciesGridProps {
    handleEdit: (row: AutomoxPoliciesColumnsType) => void;
    handleUpdateStatus: (row: AutomoxPoliciesColumnsType, status: Status) => void;
}

const ROW_PER_PAGE_OPTIONS = [10, 20, 30, 40];
export const AutomoxPoliciesGrid = () => {
    const [searchValue, setSearchValue] = useState<string>('');
    const TABLE_BODY_HEIGHT = '25rem';
    const handleUpdateStatus = (_row: AutomoxPoliciesColumnsType, _status: Status) => {};
    const handleEditClick = (_row: AutomoxPoliciesColumnsType) => {};
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setSearchValue(inputValue);
    };
    const filteredData = useMemo(() => {
        if (!AUTOMOX_POLICIES_MOCK_DATA.length) {
            return [];
        }

        const normalizedSearch = searchValue.trim().toLowerCase();

        return AUTOMOX_POLICIES_MOCK_DATA.filter((item) => item.policyName.toLowerCase().includes(normalizedSearch));
    }, [AUTOMOX_POLICIES_MOCK_DATA, searchValue]);
    return (
        <Table
            cacheKey={'findingSpecs'}
            data={filteredData}
            // dataIsLoading={true}
            columns={AUTOMOX_POLICIES_COLUMNS(handleEditClick, handleUpdateStatus)}
            rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
            transformer={(a) => a}
            showSubHeader={true}
            tableBodyHeight={TABLE_BODY_HEIGHT}
            pagination={true}
            subHeaderVariant="header-with-refresh-button"
            subHeaderContent={
                <SearchBar
                    value={searchValue}
                    onChange={handleSearchChange}
                    placeholder={SEARCH_PLACEHOLDER}
                    searchClassName="search-container__input-cont"
                />
            }
        />
    );
};

export default AutomoxPoliciesGrid;
